import { render, staticRenderFns } from "./LoadingDeadlineReportChart.vue?vue&type=template&id=b390b622&scoped=true&"
import script from "./LoadingDeadlineReportChart.vue?vue&type=script&lang=js&"
export * from "./LoadingDeadlineReportChart.vue?vue&type=script&lang=js&"
import style0 from "./LoadingDeadlineReportChart.vue?vue&type=style&index=0&id=b390b622&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b390b622",
  null
  
)

export default component.exports